export default __webpack_public_path__ + "static/media/showcase-mahligai.c574363a.png";